module.exports = __webpack_public_path__ + "img/hr-green-pita-10.38b4afb1.png";